<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-ct-dark.png";
import logoWhite from "@/assets/img/logo-ct.png";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const layout = computed(() => store.state.layout);
const sidebarType = computed(() => store.state.sidebarType);
const darkMode = computed(() => store.state.darkMode);
</script>
<template>
  <div v-show="layout === 'default'" class="min-height-300 position-absolute w-100 ctm-gradient-success ctm-bg"
    :class="`${darkMode ? 'bg-transparent' : ''}`" />

  <aside class="overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs custom-sidebar" :class="`${isRTL ? 'rotate-caret fixed-end' : 'fixed-start'}    
      ${layout === 'landing' ? 'bg-transparent shadow-none' : ' '
    } ${sidebarType}`" id="sidenav-main">
    <div class="sidenav-header">
      <i class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true" id="iconSidenav"></i>

      <router-link class="m-0 navbar-brand" to="/">
        <img :src="darkMode || sidebarType === 'bg-default' ? logoWhite : logo" class="navbar-brand-img h-100 text"
          alt="main_logo" />

        <span class="ms-2 font-weight-bold me-2 fs-13">CLINTON BUSINESS SERVICES</span>
      </router-link>
    </div>

    <hr class="mt-0 horizontal dark" />

    <sidenav-list />
  </aside>
</template>
<style>
.ctm-gradient-success {
  /* background-image: linear-gradient(310deg, #2dce89 0%, #2dcecc 100%); */
  background-color: #7b5540;
}

.fs-13 {
  font-size: 13px;
}
</style>
